/**
 * Funções utilitárias para formatação de valores
 *
 * Extraído de OrderDetails/utils/formatters para o chunk "core",
 * evitando dependências circulares entre feature chunks.
 */

import { formatLength, getStoredDisplayUnit } from '../lib/units';

/**
 * Formata um valor numérico para exibição usando a unidade escolhida pelo usuário.
 * @param value Valor em centímetros (unidade interna de OrderDetails)
 * @returns String formatada com unidade (ex: "842.3 mm", "84.23 cm", "0.842 m")
 */
export const formatValue = (value: number): string => {
  const valueMm = value * 10; // cm → mm (units.ts works with mm)
  return formatLength(valueMm, getStoredDisplayUnit());
};

/**
 * Calcula e formata a metragem total de um objeto
 * @param width Largura em centímetros
 * @param isMetros Se deve retornar em metros (true) ou unidades (false)
 * @returns String formatada com o valor e unidade
 */
export const calculateMeterage = (width: number, isMetros: boolean): string => {
  if (isMetros) {
    // Converter para metros e arredondar para cima com duas casas decimais
    return `${(Math.ceil((width / 100) * 100) / 100).toFixed(2)}m`;
  } else {
    // Para unidades, usar o valor inteiro
    return `${Math.round(width)} un`;
  }
};
